module.exports = __webpack_public_path__ + "img/bg-login.8f3e92b7.svg";